import { putApi } from "./api_instance";

export const submitRetirementDoc = async ({retirementId, formData, dispatch}) => {
  try {
    return await putApi({
      apiUrl: `/projects/api/retirements/automatic/${retirementId}`,
      dispatch,
      sendToken: true,
      data: formData,
    });
  } catch (error) {
    throw error;
  }
};
